import { defineMessages } from 'react-intl';

import { DEFAULT_VALUES } from '@/libraries/web-framework/src/localization/values';

export const messages = defineMessages({
	addChild: {
		id: 'JswInteractiveRoadmap.addChild',
		defaultMessage: 'Create child story',
	},
	avatarGroupLabel: {
		id: 'JswInteractiveRoadmap.avatarGroup',
		defaultMessage: 'Collection of user avatars showing team members',
	},
	epic: {
		id: 'JswInteractiveRoadmap.epic',
		defaultMessage: 'Epic.',
	},
	epicHeader: {
		id: 'JswInteractiveRoadmap.epicHeader',
		defaultMessage: 'Epic',
	},
	restartButton: {
		id: 'JswInteractiveRoadmap.restartButton',
		defaultMessage: 'Restart demo',
	},
	spotlightHeaderStage1: {
		id: 'JswInteractiveRoadmap.spotlightHeaderStage1',
		defaultMessage: 'Create an epic',
	},
	spotlightBodyStage1: {
		id: 'JswInteractiveRoadmap.spotlightBodyStage1',
		defaultMessage:
			'Epics represent large bodies of work that can be broken down into individual tasks.\n' +
			'Choose a name for your epic and enter it in the field to the left.',
	},
	spotlightHeaderStage2: {
		id: 'JswInteractiveRoadmap.spotlightHeaderStage2',
		defaultMessage: 'Add a story',
	},
	spotlightBodyStage2: {
		id: 'JswInteractiveRoadmap.spotlightBodyStage2.part1',
		defaultMessage:
			'<p>Each Epic contains individual tasks known as <strong>Stories.</strong></p>' +
			'<strong>Add a story</strong> by clicking the <strong>+</strong> button to the left',
		values: DEFAULT_VALUES,
	},
	spotlightHeaderStage3: {
		id: 'JswInteractiveRoadmap.spotlightHeaderStage3',
		defaultMessage: 'Name your story',
	},
	spotlightBodyStage3: {
		id: 'JswInteractiveRoadmap.spotlightBodyStage3',
		defaultMessage:
			'Describe the task that needs to be done to complete your epic then select enter.',
	},
	spotlightHeaderStage4: {
		id: 'JswInteractiveRoadmap.spotlightHeaderStage4',
		defaultMessage: 'Set a project timeline',
	},
	spotlightBodyStage4: {
		id: 'JswInteractiveRoadmap.spotlightBodyStage4',
		defaultMessage:
			'<p>Timelines represent how long an epic or story takes to complete.</p><strong>Hover</strong> and <strong>select</strong> over the timeline to enter your project dates.',
		values: DEFAULT_VALUES,
	},
	spotlightHeaderStage5: {
		id: 'JswInteractiveRoadmap.spotlightHeaderStage5',
		defaultMessage: 'Adjust timelines as plans change',
	},
	spotlightBodyStage5: {
		id: 'JswInteractiveRoadmap.spotlightBodyStage5',
		defaultMessage:
			'Extend or shorten timelines as needed by dragging either ends of the timeline bar.',
	},
	spotlightHeaderStage6: {
		id: 'JswInteractiveRoadmap.spotlightHeaderStage6',
		defaultMessage: 'Map project dependencies',
	},
	spotlightBodyStage6: {
		id: 'JswInteractiveRoadmap.spotlightBodyStage6',
		defaultMessage:
			'Dependencies can show the order that stories need to be done and highlight blockers. Select the link icon to connect stories that rely on each other.',
	},
	epicName: {
		id: 'JswInteractiveRoadmap.epicName',
		defaultMessage: 'Start a lemonade stand',
	},
	story: {
		id: 'JswInteractiveRoadmap.Story',
		defaultMessage: 'Story.',
	},
	story1Name: {
		id: 'JswInteractiveRoadmap.story1Name',
		defaultMessage: 'Create a cold, crisp, drink',
	},
	story2Name: {
		id: 'JswInteractiveRoadmap.story2Name',
		defaultMessage: 'Design a sign',
	},
	story3Name: {
		id: 'JswInteractiveRoadmap.story3Name',
		defaultMessage: 'Setup a lemonade stand',
	},
	updateEpicPlaceholder: {
		id: 'JswInteractiveRoadmap.updateEpicPlaceholder',
		defaultMessage: 'Epic: What needs to be done?',
	},
	updateStoryPlaceholder: {
		id: 'JswInteractiveRoadmap.updateStoryPlaceholder',
		defaultMessage: 'Story: What needs to be done?',
	},
	completeDemoModalHeader: {
		id: 'JswInteractiveRoadmap.completeDemoModalHeader',
		defaultMessage: "Congrats, you're timeline-ready!",
	},
	completeDemoModalSubheader: {
		id: 'JswInteractiveRoadmap.completeDemoModalSubheader',
		defaultMessage:
			"You've learned how to create epics and stories that will help keep your team on track. Close to continue adding other stories to your project or start for free in Jira.",
	},
	completeDemoModalButton: {
		id: 'JswInteractiveRoadmap.completeDemoModalButton',
		defaultMessage: 'Get Jira free',
	},
	closeDemoModalButton: {
		id: 'JswInteractiveRoadmap.closeDemoModalButton',
		defaultMessage: 'Close',
	},
	unlinkChildStoryButton: {
		id: 'JswInteractiveRoadmap.unlinkChildStoryButton',
		defaultMessage: 'Unlink child story',
	},
	linkStoriesButton: {
		id: 'JswInteractiveRoadmap.linkStoriesButton',
		defaultMessage: 'Link stories',
	},
	activateToEditTextDescription: {
		id: 'JswInteractiveRoadmap.activateToEditTextDescription',
		defaultMessage: 'Activate to edit text.',
	},
	ariaLabelLeftVerticalRoadmapBar: {
		id: 'JswInteractiveRoadmap.ariaLabelLeftVerticalRoadmapBar',
		defaultMessage: 'Left-side vertical line on timeline bar. Press space to toggle edit width.',
	},
	ariaLabelRightVerticalRoadmapBar: {
		id: 'JswInteractiveRoadmap.ariaLabelRightVerticalRoadmapBar',
		defaultMessage: 'Right-side vertical line on timeline bar. Press space to toggle edit width.',
	},
	ariaLabelSpacebarToEditKeyPress: {
		id: 'JswInteractiveRoadmap.ariaLabelSpacebarToEditKeyPress',
		defaultMessage: 'Press A or D keys to edit width of bar',
	},
	ariaLabelSpacebarToPlaceKeyPress: {
		id: 'JswInteractiveRoadmap.ariaLabelSpacebarToPlaceKeyPress',
		defaultMessage: 'Placing width of timeline bar',
	},
	ariaLabelLeftArrowPress: {
		id: 'JswInteractiveRoadmap.ariaLabelLeftArrowKeyPress',
		defaultMessage: 'Timeline bar decremented',
	},
	ariaLabelRightArrowPress: {
		id: 'JswInteractiveRoadmap.ariaLabelRightArrowPress',
		defaultMessage: 'Timeline bar incremented',
	},
});
